module.exports = __webpack_public_path__ + "img/dce74920bdcd3c06b3f6bc4332ac56fa.png";